var map = {
	"./": [
		62176
	],
	"./index": [
		62176
	],
	"./index-b72adede": [
		12579
	],
	"./index-b72adede.js": [
		12579
	],
	"./index.js": [
		62176
	],
	"./ion-icon.entry": [
		96328,
		96328
	],
	"./ion-icon.entry.js": [
		96328,
		96328
	],
	"./ionicons": [
		21978,
		21978
	],
	"./ionicons.js": [
		21978,
		21978
	],
	"./loader": [
		60517,
		60517
	],
	"./loader.js": [
		60517,
		60517
	],
	"./utils-2c56d1c8": [
		45846
	],
	"./utils-2c56d1c8.js": [
		45846
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52212;
module.exports = webpackAsyncContext;